import axiosPrivateMl from "@services/axiosPrivateMl";
import { GET_AD_ACCOUNTS_URL, GET_ALL_AD_ACCOUNTS_URL } from "../../constants";

export const fetchAdAccounts = async (userId, forceRefresh = false) => {
  try {
    console.log("Fetching ad accounts with forceRefresh:", forceRefresh, "userId:", userId);
    const response = await axiosPrivateMl.post(GET_AD_ACCOUNTS_URL, {
      user_id: userId,
      force_refresh: forceRefresh
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching ad accounts:', error);
    throw error;
  }
};


export const fetchAllAdAccounts = async (userId, forceRefresh = false) => {
  try {
    const response = await axiosPrivateMl.post(GET_ALL_AD_ACCOUNTS_URL, {
      user_id: userId,
      force_refresh: forceRefresh
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching all ad accounts:', error);
    throw error;
  }
};
